import { html, css, LitElement } from 'lit-element';
//import { backdrop } from './styles';


 export class AppInput extends LitElement {

  static get styles() {
  //  return [backdrop]
  }

  static get properties() {
    return {
      active: { type: Boolean },
      disabled: { type: Boolean },
      data: { type: Object },
      value: { type: String },
      invalid: { type: Boolean },
      valid: { type: Boolean },
    };
  }


  constructor() {
    super(...arguments);
    this.active = false;
    this.disabled = false;
    this.invalid = false;
    this.valid = false;
    this.data = {};
    this.value= '';
  }






  render() {
    const { active, disabled, invalid, data} = this;


    const getCheck = (data) => data.elements
      .map(items => html`
      <label class="container ${data.type}">
      <input
      type="${data.type}"
      name="${data.name}"
      value="${items.value}"
      ?checked=${this.checked}
      @change="${e => this._changeHandler(e)}"
      >
    ${items.label}
      <span class="check"></span>
      </label>
    `
    )


    const getInput = (input) => html`
      <input
      type="text"
      autocomplete="off"
      name="${input.name}"
      pattern="${input.pattern}"
      ?required="${input.required}"
      ?invalid="${this.invalid}"
      ?custom="${this.custom}"
      @change="${e => this._changeHandler(e)}"
      @focus="${e => this._focusHandler(e)}"
      @blur="${e => this._blurredHandler(e)}"
      >
      `
//      disabled

      const getSelect = (select) => html`
      <select
      type="select"
      name=${select.name}
      class=${select.class}
      ?required=${select.required}
      ?disabled="${this.disabled}"
      ?invalid="${this.invalid}"
      ?multi="${this.multi}"
      @change="${e => this._changeHandler(e)}"
      @focus="${e => this._focusHandler(e)}"
      @blur="${e => this._blurredHandler(e)}"
      >
      <option disabled selected value></option>
      ${select.elements
        .map(items => html`<option value="${items.value||items}">${items.label||items}</option>`
        )}
      </select>
        `

        const getMultiSelect = (select) => html`
      multi
          `




    return html`
    <style>


.controls{text-align:left;position:relative;}.controls button,.controls input[type=email],.controls input[type=tel],.controls input[type=text],.controls select,.controls textarea{padding:12px 16px;border:1px solid #c6c6c6;width:100%;color:#888;font-size:1em;line-height:1.5;font-weight:300;background-color:#fff;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px}.controls button:focus,.controls button:hover,.controls input[type=email]:focus,.controls input[type=email]:hover,.controls input[type=tel]:focus,.controls input[type=tel]:hover,.controls input[type=text]:focus,.controls input[type=text]:hover,.controls select:focus,.controls select:not([disabled]):hover,.controls textarea:focus,.controls textarea:hover{outline:0;border-color:#9fb1c1}.controls button:focus+label,.controls button:hover+label,.controls input[type=email]:focus+label,.controls input[type=email]:hover+label,.controls input[type=tel]:focus+label,.controls input[type=tel]:hover+label,.controls input[type=text]:focus+label,.controls input[type=text]:hover+label,.controls select:focus+label,.controls select:not([disabled]):hover+label,.controls textarea:focus+label,.controls textarea:hover+label{color:#077abc;cursor:text}.controls select[disabled]:hover{cursor:default}.controls select{-moz-appearance:none;-webkit-appearance:none;cursor:pointer;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNy40MSA4LjU5TDEyIDEzLjE3bDQuNTktNC41OEwxOCAxMGwtNiA2LTYtNiAxLjQxLTEuNDF6Ii8+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ii8+PC9zdmc+);background-position:right center;background-origin:content-box;background-repeat:no-repeat}.controls.select label,.controls.text label{position:absolute;left:12px;top:14px;line-height:1;color:#999;font-size:1em;display:inline-block;padding:4px 6px;font-weight:400;background-color:rgba(255,255,255,0);pointer-events:none;-webkit-transform:none;transform:none;transition:transform .2s ease;transform-origin:top left;color:rgba(0,0,0,.5)}.controls textarea{resize:none;height:200px}.controls button{cursor:pointer;background-color:#07b3a1;border:none;color:#fff;padding:12px 0}.controls button:hover{background-color:#08ccb7}.controls.select label[active],.controls.text label[active]{color:#555;background-color:#fff;font-size:.775em;transition:transform .2s ease;-webkit-transform:scale(.9) translate(-4px,-28px);transform:scale(.9) translate(-4px,-28px);transform-origin:top left}.controls select~::after,.controls.text input~::after{content:attr(data-info);color:rgba(0,0,0,.5);font-size:.8em;display:inline-block;width:100%;padding-left:4px}.controls select[custom],.controls select[invalid],.controls.text input[custom],.controls.text input[invalid]{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBzdHlsZT0iZmlsbDojZjk4OWFiOyIgZD0iTTE5IDYuNDFMMTcuNTkgNSAxMiAxMC41OSA2LjQxIDUgNSA2LjQxIDEwLjU5IDEyIDUgMTcuNTkgNi40MSAxOSAxMiAxMy40MSAxNy41OSAxOSAxOSAxNy41OSAxMy40MSAxMnoiLz48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PC9zdmc+Cg==);background-position:right center;background-origin:content-box;background-repeat:no-repeat;border:1px solid #f989ab}.controls select[invalid]~::after,.controls.text input[invalid]~::after{content:attr(data-error);color:#d50000}.controls select[custom]~::after,.controls.text input[custom]~::after{content:attr(data-info);color:#d50000}.controls select:valid:not([custom]),.controls.text input:valid:not([custom]){background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggc3R5bGU9ImZpbGw6IzE5QTk3NDsiIGQ9Ik05IDE2LjJMNC44IDEybC0xLjQgMS40TDkgMTkgMjEgN2wtMS40LTEuNEw5IDE2LjJ6Ii8+PC9zdmc+Cg==);background-position:right center;background-repeat:no-repeat;background-origin:content-box}.controls select:valid:not([custom])~::after,.controls.text input:valid:not([custom])~::after{content:''}

    /*Input radio & checkbox*/
label.container input[type=checkbox],label.container input[type=radio]{position:absolute;opacity:0;cursor:pointer}label.container input[type=checkbox]{height:0;width:0}label.container span{position:absolute;top:0;left:0;height:25px;width:25px;background-color:rgba(0,0,0,.1);cursor:pointer}label.container.radio span{border-radius:50%}label.container:hover input~span{background-color:rgba(0,0,0,.2)}label.container input:checked~span{background-color:#2196f3}label.container span:after{content:"";position:absolute;display:none}label.container input:checked~span:after{display:block}label.container.checkbox span:after{left:9px;top:5px;width:5px;height:10px;border:solid #fff;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}label.container.radio span:after{top:9px;left:9px;width:8px;height:8px;border-radius:50%;background:#fff}label.container{display:inline-block;position:relative;padding-left:2.1rem;padding-right:1rem;margin-top:0;margin-left:5px;color:rgba(0,0,0,.5)}input[type=radio]{display:none}.radio span::after{content:'';color:rgba(0,0,0,.5);font-size:.8em;display:inline-block;width:100%}.radio span[invalid]::after{content:attr(data-error);color:#d50000}.radio span:valid::after{content:''}






    .controls.radio, .controls.checkbox  {
      text-align: left;
      position: relative;
      padding-bottom:1rem;

    }



    * {
    box-sizing: border-box;
    }

    [disabled] {
    opacity: .3;
    }






      .pl1{
        padding-left:1rem;
      }

    .flex-grow1{flex-grow:1};
    .flex-grow2{flex-grow:2}

    .items-stretch{align-items:stretch}
    .flex-wrap{flex-wrap:wrap}

    .w-100{width:100%}
    .w-50{width:50%}



    @media screen and (min-width:30em) {
      .pl1-ns {
        padding-left:1rem;
      }

      .w-50-ns {
        width:50%
      }

    }


    </style>



    <div class="controls ${data.type}">
    <label ?active="${active}" for="${data.name}">${data.label}</label>
    ${data.type==='text' ? getInput(data)
    : data.type==='select' ? getSelect(data)
    : data.type==='checkbox' || data.type==='radio'  ? getCheck(data)
    : null
    }

    ${data.info || data.errorMessage
      ? html `<span data-info='${data.info||''}' data-error=${data.errorMessage}></span>`
      : null
    }

    </div>

    `;
  }

  firstUpdated(){
    this.disabled=this.data.disabled?true:false;
    this.valid= this.data.required? false : true;
}

_formatValidData(e){
  //console.log({isValid: !e.target.invalid, name:e.target.name, value:e.target.value, targetType:e.target.type, eventType: e.type, timestamp: e.timeStamp})
  if(e.target.type==='checkbox'){
    this.value=this.value||[];
    this.value.push(e.target.value);
  }else{
    this.value=e.target.value;
  }
}



_updateChildMenus (e) {
  const childs= this.data.childs;
  const parent= this.parentElement;

  childs.map((child, i) => {
    const target= parent.querySelector('#'+child);
    target.shadowRoot.querySelector('select').value='';

    target.active=false;
    target.value='';
    target.valid= target.data.required ? false : true;
    target.disabled= i>0 ? true : false;
    target.data.elements= i===0 ? this.data.data[e.target.value] : [];

  })

}



  _changeHandler(e, data) {
  e.preventDefault();
  e.target.setCustomValidity('');
  this.invalid=!e.target.checkValidity();

  if(this.invalid && e.target.custom){
    console.log('invalid custom');
    this.valid=false;
  } else if (this.invalid){
    this.valid=false;
  }else{
    this.valid=true;
    this._formatValidData(e);
    this.data.childs ? this._updateChildMenus(e): null;

  }


  }

  _focusHandler(e, data) {
  e.preventDefault();
  this.active=true;
  }

  _blurredHandler(e, data) {
  e.preventDefault();
  if(!e.target.value){
    this.active=false;
  }


  }




}
